if (
  localStorage.getItem("Idioma") === null ||
  localStorage.getItem("Idioma") === undefined
) {
  localStorage.setItem("Idioma", "Español");
}

function TraducirEstado(Estado) {
  let EstadoTraducido = Estado;

  if (localStorage.getItem("Idioma") === "English") {
    if (Estado === "PENDIENTE") EstadoTraducido = "Pending";
    if (Estado === "CONDUCTOR ASIGNADO") EstadoTraducido = "Assigned driver";
    if (Estado === "CONFIRMAR IMPORTE") EstadoTraducido = "Confirm amount";
    if (Estado === "RUTA DE VIAJE ACTIVADA")
      EstadoTraducido = "Travel route activated";
    if (Estado === "TRANSITO ACTIVADO") EstadoTraducido = "Transit activated";
    if (Estado === "EN CURSO") EstadoTraducido = "In progress";
    if (Estado === "FINALIZADO") EstadoTraducido = "Finalized";
    if (Estado === "VALORADO") EstadoTraducido = "Valued";
    if (Estado === "CANCELADO") EstadoTraducido = "Cancelled";
  }

  if (localStorage.getItem("Idioma") === "Português") {
    if (Estado === "PENDIENTE") EstadoTraducido = "Brinco";
    if (Estado === "CONDUCTOR ASIGNADO")
      EstadoTraducido = "Motorista atribuído";
    if (Estado === "CONFIRMAR IMPORTE") EstadoTraducido = "Confirme o valor";
    if (Estado === "RUTA DE VIAJE ACTIVADA")
      EstadoTraducido = "Rota de viagem ativada";
    if (Estado === "TRANSITO ACTIVADO") EstadoTraducido = "Trânsito ativado";
    if (Estado === "EN CURSO") EstadoTraducido = "No curso";
    if (Estado === "FINALIZADO") EstadoTraducido = "Finalizado";
    if (Estado === "VALORADO") EstadoTraducido = "Valorizado";
    if (Estado === "CANCELADO") EstadoTraducido = "Cancelado";
  }

  return EstadoTraducido;
}

let recibo = "Recibo";
let sin_datos = "Sin datos";
let tocar_afuera_para_cerrar = "Tocar afuera para cerrar";
let cargando = "Cargando";
let descargar = "Descargar";
let calcular = "Calcular";
let borrar = "Borrar";
let centrar = "Centrar";
let sin_servicio_en_tu_zona =
  "Actualmente no contamos con choferes en tu localidad. Te avisaremos cuando estemos operativos en tu zona. Gracias por interesarte en Local Point";
let cargando_mapa = "Cargando mapa...";
let tu_ubicacion = "Tu ubicación";
let punto_destino = "Punto destino";
let punto_de_partida = "Punto de partida";
let pendiente_de_abonar = "Pendiente de abonar";
let buscando_conductor = "Buscando conductor";
let viaje_abonado = "Viaje abonado";
let pagar_viaje = "Pagar viaje";
let el_conductor_esta_esperandote = "El conductor está esperándote";
let conductor_asignado = "Conductor asignado";
let permitir_notificaciones = "Permitir notificaciones";
let no_es_posible_obtener_el_token_de_notificaciones =
  "No es posible obtener el token de notificaciones";
let para_un_correcto_funcionamiento_de_la_aplicacion_debe_activar_las_notificaciones =
  "Para un correcto funcionamiento de la aplicacion debe activar las notificaciones";
let cambio_de_estado_de_viaje = "Cambio de estado de viaje";
let pago = "Pago";
let avisar_al_pasajero_que_debe_agregar_un_metodo_de_pago_valido =
  "Avisar al pasajero que debe agregar un método de pago válido";
let avisar_a_pasajero = "Avisar a pasajero";
let viaje_aun_no_abonado = "Viaje aún no abonado";
let falta_agregar_metodo_de_pago_valido = "Falta agregar método de pago válido";
let cambiar_metodo_de_pago = "Cambiar método de pago";
let tarjeta_terminada_en = "Tarjeta terminada en";
let metodo_de_pago_registrado_con_exito = "Método de pago registrado con éxito";
let guardar_metodo_de_pago = "¿Guardar método de pago?";
let metodo_de_pago = "Método de pago";
let para_continuar_debes_activar_el_gps = "Para continuar debes activar el GPS";
let viaje_no_aceptado = "Viaje no aceptado";
let intentaremos_ofrecerte_una_mejor_oferta =
  "Intentaremos ofrecerte una mejor oferta";
let viaje_aceptado_correctamente = "Viaje aceptado correctamente";
let no = "No";
let buscar_calle = "Buscar calle";
let no_se_encontro_ninguna_direccion = "No se encontró ninguna dirección";
let direccion_de_partida = "Dirección de partida";
let numero_de_tarjeta_credito_debito = "Número de tarjeta (crédito o débito)";
let debe_estar_entre_1_y_12 = "Debe estar entre 1 y 12";
let solo_acepta_numeros = "Solo acepta números";
let debe_contener_16_numeros = "Debe contener 16 números";
let numero = "Número";
let titular_tarjeta = "Tiular";
let numero_de_identificacion = "Número de identificación (DNI, PAS)";
let expira_mm = "Expira (MM)";
let expira_aaaa = "Expira (AAAA)";
let cvv = "CVV";
let agregar_metodo_de_pago = "Agregar método de pago";
let total = "Total";
let importe_acreditado = "Importe acreditado";
let datos_de_pasajero = "Datos de pasajero";
let todos = "Todos";
let ver_en_google_maps = "Ver en Google Maps";
let modelo = "Modelo";
let estado = "Estado";
let importe = "Importe";
let nombre_conductor = "Nombre conductor";
let fecha_hora = "Fecha/Hora";
let ultimo_mes = "Último mes";
let ultimos_tres_meses = "Últimos tres meses";
let ultimos_seis_meses = "Últimos seis meses";
let filtrar_por = "Filtrar por";
let historial_de_viajes = "Historial de viajes";
let valoracion_enviada_correctamente = "Valoración enviada correctamente";
let viaje_finalizado_correctamente = "Viaje finalizado correctamente";
let ruta_activada_correctamente = "Ruta activada correctamente";
let activar_ruta_de_viaje = "Activar ruta de viaje";
let finalizar_viaje = "Finalizar viaje";
let levantar_pasajero = "Levantar pasajero";
let ver_recorrido_en_google_maps = "Ver recorrido en Google Maps";
let ver_recorrido = "Ver recorrido";
let enviar_valoracion = "Enviar valoración";
let transito_activado_correctamente = "Tránsito activado correctamente";
let no_es_posible_activar_el_tránsito_debido_a_que_tu_ubicación_no_es_correcta =
  "No es posible activar el tránsito debido a que tu ubicación no es correcta";
let no_es_posible_finalizar_el_viaje_debido_a_que_tu_ubicación_no_es_correcta =
  "No es posible finalizar el viaje debido a que tu ubicación no es correcta";
let ayudanos_a_mejorar_nuestro_servicio_y_valora_los_siguientes_items =
  "Ayúdanos a mejorar nuestro servicio y valora los siguientes items";
let viaje_finalizado = "Viaje finalizado";
let en_viaje = "En viaje";
let te_avisaremos_cuando_se_encuentre_en_tu_ubicacion =
  "Te avisaremos cuando se encuentre en tu ubicación";
let conductor_en_camino = "Conductor en camino";
let tiempo_de_llegada_estimado = "Tiempo de llegada (estimado)";
let buscar_en = "Buscar en";
let ruta_de_viaje_activada = "Ruta de viaje activada";
let notificacion_de_pickup = "Notificación de pickup";
let en_instantes_iniciara_el_recorrido_para_venir_a_buscarte =
  "En instantes iniciará el recorrido para venir a buscarte";
let dominio = "Dominio";
let vehiculo = "Vehículo";
let hemos_encontrado_un_conductor_para_ti =
  "Hermos encontrado un conductor para ti";
let lo_aceptas = "¿Lo aceptas?";
let tienes_un_viaje_asignado = "Tienes un viaje asignado";
let estamos_buscando_un_conductor_cercano_para_ti =
  "Estamos buscando un conductor cercano para ti...";
let tienes_un_viaje_con_destino_a = "Tienes un viaje con destino a: ";
let vas_a_cerrar_la_sesion = "¿Vas a cerrar la sesión?";
let pendiente_de_asignar_conductor = "Pendiente de asignar conductor";
let viaje_cancelado_con_exito = "Viaje cancelado con éxito";
let el_viaje_no_podra_recuperarse_posterior_a_esta_accion =
  "El viaje no podrá recuperarse posterior a esta acción";
let cambiar_idioma = "Cambiar idioma";
let seleccionar_idioma = "Seleccionar idioma";
let selecciona_idioma = "Selecciona idioma";
let continuar = "Continuar";
let seleccionar_localidad = "Seleccionar localidad";
let selecciona_localidad = "Selecciona localidad";
let activar_cuenta = "Activar cuenta";
let ingresa_el_codigo_de_activacion = "Ingresa el código de activación";
let codigo_de_activacion = "Código de activación";
let cambiar_contrasena = "Cambiar contraseña";
let nueva_contrasena = "Nueva contraseña";
let repetir_contrasena = "Repetir contraseña";
let guardar_cambios = "Guardar cambios";
let crear_cuenta_de_pasajero = "Crear cuenta de pasajero";
let nombre = "Nombre";
let apellido = "Apellido";
let email = "Email";
let telefono = "Teléfono";
let contrasena = "Contraseña";
let aceptar_las_condiciones_del_servicio =
  "Aceptar las condiciones del servicio";
let crear_cuenta = "Crear cuenta";
let ingresar = "Ingresar";
let politica_de_privacidad = "Política de privacidad";
let condiciones_del_servicio = "Condiciones del servicio";
let cerrar = "Cerrar";
let campo_obligatorio = "Campo obligatorio";
let las_contrasenas_deben_coincidir = "Las contraseñas deben coincidir";
let email_invalido = "Email inválido";
let recuerdame = "Recuérdame";
let olvidaste_tu_contrasena = "Olvidaste tu contraseña";
let necesitas_ayuda_con_tu_contrasena = "¿Necesitás ayuda con tu contraseña?";
let ingresa_el_codigo_de_recuperacion_que_recibiste_en_tu_casilla_de_correo =
  "Ingresa el código de recuperación que recibiste en tu casilla de correo";
let siguiente = "Siguiente";
let ingresa_el_correo_electronico_que_utilizas_en_local_point_y_te_ayudaremos_a_crear_una_nueva_contrasena =
  "Ingresá el correo electrónico que utilizás en Local Point y te ayudaremos a crear una nueva contraseña";
let reenviar_codigo_de_activacion = "Reenviar código de activación";
let codigo_de_activacion_reenviado_correctamente =
  "Código de activación reenviado correctamente";
let email_requerido = "Email requerido";
let codigo_de_recuperacion = "Código de recuperación";
let codigo_de_recuperacion_incorrecto = "Código de recuperación incorrecto";
let debe_contener_letras_mayusculas_y_minusculas_al_menos_1_caracter_numerico_y_el_tamano_debe_ser_de_6_a_15_caracteres =
  "Debe contener al menos letra 1 letra mayúscula, 1 caracter numérico, 1 caracter especial y el tamaño debe ser entre 6 y 15 caracteres";
let proceso_de_cambio_de_clave_incorrecto =
  "Proceso de cambio de clave incorrecto";
let cambio_de_contrasena_correcto = "Cambio de contraseña correcto";
let cambios_registrados_correctamente = "Cambios registrados correctamente";
let error_al_guardar_cambios = "Error al guardar cambios";
let comenzar = "Comenzar";
let mis_viajes = "Mis viajes";
let activo = "Activo";
let inactivo = "Inactivo";
let menu = "Menu";
let editar_perfil = "Editar perfil";
let cerrar_sesion = "Cerrar sesión";
let idioma = "Idioma";
let localidad = "Localidad";
let contacto = "Contacto";
let avatar = "Avatar";
let general = "General";
let otros = "Otros";
let contactos_de_emergencia = "Contactos de emergencia";
let vas_a_cambiar_el_estado_de_tu_vehiculo =
  "¿Vas a cambiar el estado de tu vehículo?";
let tu_nuevo_estado_sera = "Tu nuevo estado será";
let si = "Si";
let cancelar = "Cancelar";
let cambio_de_estado_completado_con_exito =
  "Cambio de estado completado con éxito";
let ahora_tu_estado_es = "Ahora tu estado es";
let inicio = "Inicio";
let billetera = "Billetera";
let conductor = "Conductor";
let pasajero = "Pasajero";
let administrador = "Administrador";
let selecciona_imagen = "Selecciona imagen";
let nuevo_viaje = "Nuevo viaje";
let dispositivo_movil_no_detectado = "Dispositivo móvil no detectado";
let instalar_aplicacion = "Instalar aplicación";
let datos_incorrectos = "Datos incorrectos";
let sin_conexion_a_internet = "Sin conexión a internet";
let sin_conexion_a_gps = "Sin conexión a GPS";
let intentando_reconectar = "Intentando reconectar...";
let conectado = "Conectado";
let desconectado = "Desconectado";
let partida = "Partida";
let destino = "Destino";
let ubicacion_de_partida = "Ubicación de partida";
let ubicacion_destino = "Ubicación destino";
let banco = "Banco";
let nombre_Banco = "Nombre del banco";
let titular = "Titular";
let el_correo_electronico_existe_prueba_con_otro =
  "El correo electrónico existe, prueba con otro";
let ya_se_ha_registrado_un_usuario_con_este_email =
  "Ya se ha registrado un usuario con este mail";
let hola = "Hola";
let historial = "Historial";
let no_tienes_viajes_pendientes = "No tienes viajes pendientes";
let solicita_un_viaje_en_cualquier_momento_en_cualquier_lugar =
  "Solicita un viaje en cualquier momento, en cualquier lugar";
let selecciona_punto_de_partida = "Selecciona punto de partida";
let partida_utilizar_ubicacion_actual = "Partida: Utilizar ubicación actual";
let ingresar_ubicacion_de_partida = "Ingresar ubicación de partida";
let ingresa_punto_de_partida = "Ingresa punto de partida";
let esperando_asignacion_de_viaje = "Esperando asignación de viaje";
let selecciona_punto_destino = "Selecciona punto destino";
let ingresa_punto_destino = "Ingresa punto destino";
let vas_a_confirmar_el_viaje = "¿Vas a confirmar el viaje?";
let viaje_registrado_con_exito = "Viaje registrado con éxito";
let tienes_un_viaje_en_curso = "Tienes un viaje en curso";
let en_cuanto_finalice_el_mismo_podras_solicitar_uno_nuevo =
  "En cuanto finalice el mismo, podrás solicitar uno nuevo";
let resumen_del_viaje = "Resumen del viaje";
let trayecto = "Trayecto";
let resumen = "Resumen";
let confirmar = "Confirmar";
let calcular_trayecto = "Calcular trayecto";
let vas_a_cancelar_el_viaje_seleccionado =
  "¿Vas a cancelar el viaje seleccionado?";

//////////////////////////////////////////////////////////////////////

if (localStorage.getItem("Idioma") === "English") {
  recibo = "Receipt";
  sin_datos = "No data";
  tocar_afuera_para_cerrar = "Tap outside to close";
  cargando = "Loading";
  descargar = "Download";
  calcular = "Calculate";
  borrar = "Reset";
  centrar = "Center";
  sin_servicio_en_tu_zona =
    "We currently do not have drivers in your location. We will notify you when we are operational in your area. Thank you for your interest in Local Point";
  cargando_mapa = "Loading map...";
  tu_ubicacion = "Your location";
  punto_destino = "Destination point";
  punto_de_partida = "Starting point";
  pendiente_de_abonar = "Pending payment";
  buscando_conductor = "Looking for driver";
  viaje_abonado = "Paid trip";
  pagar_viaje = "Pay trip";
  el_conductor_esta_esperandote = "The driver is waiting for you";
  conductor_asignado = "Assigned driver";
  permitir_notificaciones = "Enable notifications";
  no_es_posible_obtener_el_token_de_notificaciones =
    "Unable to get notification token";
  para_un_correcto_funcionamiento_de_la_aplicacion_debe_activar_las_notificaciones =
    "For correct operation of the application you must activate notifications";
  cambio_de_estado_de_viaje = "Change of travel status";
  pago = "Pay";
  avisar_al_pasajero_que_debe_agregar_un_metodo_de_pago_valido =
    "Notify the passenger that they must add a valid payment method";
  avisar_a_pasajero = "Notify passenger";
  viaje_aun_no_abonado = "Trip not yet paid";
  falta_agregar_metodo_de_pago_valido = "Missing to add valid payment method";
  cambiar_metodo_de_pago = "Change payment method";
  tarjeta_terminada_en = "Card finished in";
  metodo_de_pago_registrado_con_exito =
    "Payment method successfully registered";
  guardar_metodo_de_pago = "Save payment method?";
  metodo_de_pago = "Payment method";
  para_continuar_debes_activar_el_gps = "To continue you must activate GPS";
  viaje_no_aceptado = "Travel not accepted";
  intentaremos_ofrecerte_una_mejor_oferta =
    "We will try to offer you a better offer";
  viaje_aceptado_correctamente = "Trip accepted successfully";
  buscar_calle = "Search street";
  no_se_encontro_ninguna_direccion = "No address found";
  direccion_de_partida = "Departure address";
  numero_de_tarjeta_credito_debito = "Card number (credit or debit)";
  debe_estar_entre_1_y_12 = "It must be between 1 and 12";
  solo_acepta_numeros = "Only accept numbers";
  debe_contener_16_numeros = "Must contain 16 numbers";
  numero = "Number";
  titular_tarjeta = "Full name";
  numero_de_identificacion = "Identification number (DNI, PAS)";
  expira_mm = "Expiration (MM)";
  expira_aaaa = "Expiration (AAAA)";
  cvv = "CVV";
  agregar_metodo_de_pago = "Add payment method";
  total = "Total";
  importe_acreditado = "Amount credited";
  datos_de_pasajero = "Passenger data";
  todos = "All";
  ver_en_google_maps = "View on Google Maps";
  modelo = "Model";
  estado = "State";
  importe = "Amount";
  nombre_conductor = "Driver name";
  fecha_hora = "Date/Hour";
  ultimo_mes = "Last month";
  ultimos_tres_meses = "Last three months";
  ultimos_seis_meses = "Last six months";
  filtrar_por = "Filter by";
  historial_de_viajes = "Travel history";
  valoracion_enviada_correctamente = "Review sent correctly";
  viaje_finalizado_correctamente = "Trip completed successfully";
  ruta_activada_correctamente = "Route activated correctly";
  activar_ruta_de_viaje = "Activate travel route";
  finalizar_viaje = "End trip";
  levantar_pasajero = "Raise passenger";
  ver_recorrido_en_google_maps = "See route on Google Maps";
  ver_recorrido = "See route";
  enviar_valoracion = "Submit review";
  transito_activado_correctamente = "Transit activated correctly";
  no_es_posible_activar_el_tránsito_debido_a_que_tu_ubicación_no_es_correcta =
    "It is not possible to activate transit because your location is not correct";
  no_es_posible_finalizar_el_viaje_debido_a_que_tu_ubicación_no_es_correcta =
    "It is not possible to end the trip because your location is not correct";
  ayudanos_a_mejorar_nuestro_servicio_y_valora_los_siguientes_items =
    "Help us improve our service and rate the following items";
  viaje_finalizado = "Trip completed";
  en_viaje = "In travel";
  te_avisaremos_cuando_se_encuentre_en_tu_ubicacion =
    "We will notify you when it is at your location";
  conductor_en_camino = "Driver on the way";
  tiempo_de_llegada_estimado = "Arrival time (estimated)";
  buscar_en = "Search in";
  ruta_de_viaje_activada = "Travel route activated";
  notificacion_de_pickup = "Pickup notification";
  en_instantes_iniciara_el_recorrido_para_venir_a_buscarte =
    "In moments the journey will begin to come and pick you up";
  dominio = "Domain";
  vehiculo = "Vehicle";
  hemos_encontrado_un_conductor_para_ti = "We have found a driver for you";
  lo_aceptas = "Do you accept it?";
  tienes_un_viaje_asignado = "You have an assigned trip";
  estamos_buscando_un_conductor_cercano_para_ti =
    "We are looking for a driver nearby for you...";
  tienes_un_viaje_con_destino_a = "You have a trip to: ";
  vas_a_cerrar_la_sesion = "Are you going to log out?";
  pendiente_de_asignar_conductor = "Pending driver assignment";
  viaje_cancelado_con_exito = "Trip canceled successfully";
  el_viaje_no_podra_recuperarse_posterior_a_esta_accion =
    "The trip cannot be recovered after this action";
  cambiar_idioma = "Change language";
  seleccionar_idioma = "Select language";
  selecciona_idioma = "Select language";
  continuar = "Continue";
  seleccionar_localidad = "Select location";
  selecciona_localidad = "Select location";
  activar_cuenta = "Activate account";
  ingresa_el_codigo_de_activacion =
    "Enter the activation code what you received in your mailbox";
  codigo_de_activacion = "Activation code";
  cambiar_contrasena = "Change Password";
  nueva_contrasena = "New Password";
  repetir_contrasena = "Repeat password";
  guardar_cambios = "Save Changes";
  crear_cuenta_de_pasajero = "Create passenger account";
  nombre = "Name";
  apellido = "Last name";
  email = "E-mail";
  telefono = "Phone";
  contrasena = "Password";
  repetir_contrasena = "Repeat password";
  aceptar_las_condiciones_del_servicio = "Accept the conditions of service";
  crear_cuenta = "Create Account";
  ingresar = "Login";
  politica_de_privacidad = "Privacy policy";
  condiciones_del_servicio = "Conditions of service";
  cerrar = "Close";
  campo_obligatorio = "Required";
  las_contrasenas_deben_coincidir = "Passwords must match";
  email_invalido = "Invalid email";
  recuerdame = "Remember me";
  olvidaste_tu_contrasena = "Did you forget your password";
  necesitas_ayuda_con_tu_contrasena = "Do you need help with your password?";
  ingresa_el_codigo_de_recuperacion_que_recibiste_en_tu_casilla_de_correo =
    "Enter the recovery code what you received in your mailbox";
  siguiente = "Next";
  ingresa_el_correo_electronico_que_utilizas_en_local_point_y_te_ayudaremos_a_crear_una_nueva_contrasena =
    "Enter the email you use in Local Point and we will help you create a new password";
  reenviar_codigo_de_activacion = "Resend activation code";
  codigo_de_activacion_reenviado_correctamente =
    "Activation code successfully forwarded";
  email_requerido = "Email required";
  codigo_de_recuperacion = "Recovery code";
  codigo_de_recuperacion_incorrecto = "Incorrect recovery code";
  debe_contener_letras_mayusculas_y_minusculas_al_menos_1_caracter_numerico_y_el_tamano_debe_ser_de_6_a_15_caracteres =
    "It must contain at least 1 uppercase letter, 1 numeric character, 1 special character and the size must be between 6 and 15 characters";
  proceso_de_cambio_de_clave_incorrecto = "Incorrect new key process";
  cambio_de_contrasena_correcto = "Successful password change";
  cambios_registrados_correctamente = "Changes registered correctly";
  error_al_guardar_cambios = "Error saving changes";
  comenzar = "Begin";
  mis_viajes = "My trips";
  activo = "On";
  inactivo = "Off";
  menu = "Menu";
  editar_perfil = "Edit profile";
  cambiar_contrasena = "Change Password";
  cerrar_sesion = "Sign off";
  idioma = "Language";
  localidad = "Location";
  contacto = "Contact";
  avatar = "Avatar";
  general = "General";
  otros = "Others";
  contactos_de_emergencia = "Emergency contacts";
  vas_a_cambiar_el_estado_de_tu_vehiculo =
    "Are you going to change the status of your vehicle?";
  tu_nuevo_estado_sera = "Your new state will be";
  si = "Yes";
  cancelar = "Cancel";
  cambio_de_estado_completado_con_exito =
    "Status change completed successfully";
  ahora_tu_estado_es = "Now your status is";
  inicio = "Home";
  billetera = "Wallet";
  conductor = "Driver";
  pasajero = "Passenger";
  administrador = "Administrator";
  selecciona_imagen = "Select image";
  nuevo_viaje = "New trip";
  dispositivo_movil_no_detectado = "Mobile device not detected";
  instalar_aplicacion = "Install application";
  datos_incorrectos = "Incorrect data";
  sin_conexion_a_internet = "No internet connection";
  sin_conexion_a_gps = "No GPS connection";
  intentando_reconectar = "Trying to reconnect...";
  conectado = "Connected";
  desconectado = "Disconnected";
  partida = "Starting";
  destino = "Destination";
  ubicacion_de_partida = "Starting location";
  ubicacion_destino = "Destination location";
  banco = "Bank";
  nombre_Banco = "Name of the bank";
  titular = "Headline";
  el_correo_electronico_existe_prueba_con_otro =
    "The email exists, try another one";
  ya_se_ha_registrado_un_usuario_con_este_email =
    "A user has already registered with this email";
  hola = "Hello";
  historial = "Record";
  no_tienes_viajes_pendientes = "You have no pending trips";
  solicita_un_viaje_en_cualquier_momento_en_cualquier_lugar =
    "Request a ride anytime, anywhere";
  selecciona_punto_de_partida = "Select starting point";
  partida_utilizar_ubicacion_actual = "Starting point: Use current location";
  ingresar_ubicacion_de_partida = "Enter departure location";
  ingresa_punto_de_partida = "Enter starting point";
  esperando_asignacion_de_viaje = "Waiting for travel assignment";
  selecciona_punto_destino = "Select destination point";
  ingresa_punto_destino = "Enter destination point";
  vas_a_confirmar_el_viaje = "Are you going to confirm the trip?";
  viaje_registrado_con_exito = "Trip successfully recorded";
  tienes_un_viaje_en_curso = "You have a trip in progress";
  en_cuanto_finalice_el_mismo_podras_solicitar_uno_nuevo =
    "As soon as it ends, you can request a new one";
  resumen_del_viaje = "Trip Summary";
  trayecto = "Journey";
  resumen = "Summary";
  confirmar = "Confirm";
  calcular_trayecto = "Calculate route";
  vas_a_cancelar_el_viaje_seleccionado =
    "Are you going to cancel the selected trip?";
}

//////////////////////////////////////////////////////////////////////

if (localStorage.getItem("Idioma") === "Português") {
  recibo = "Recibo";
  sin_datos = "Não há dados";
  tocar_afuera_para_cerrar = "Toque fora para fechar";
  cargando = "Carregando";
  descargar = "Descarga";
  calcular = "Calcular";
  borrar = "Reiniciar";
  centrar = "Centro";
  sin_servicio_en_tu_zona =
    "No momento não temos motoristas em sua localidade. Iremos notificá-lo quando estivermos operacionais em sua área. Obrigado pelo seu interesse no Local Point";
  cargando_mapa = "Carregando mapa";
  tu_ubicacion = "Sua localização";
  punto_destino = "Ponto de destino";
  pendiente_de_abonar = "Pagamento Pendente";
  buscando_conductor = "Procurando motorista";
  viaje_abonado = "Viagem paga";
  pagar_viaje = "Pagar viagem";
  el_conductor_esta_esperandote = "O motorista está esperando por você";
  conductor_asignado = "Motorista atribuído";
  permitir_notificaciones = "Ativar notificações";
  no_es_posible_obtener_el_token_de_notificaciones =
    "Não foi possível obter o token de notificação";
  cambio_de_estado_de_viaje = "Mudança de status de viagem";
  pago = "Pagar";
  avisar_al_pasajero_que_debe_agregar_un_metodo_de_pago_valido =
    "Notifique o passageiro de que ele deve adicionar uma forma de pagamento válida";
  avisar_a_pasajero = "Notificar passageiro";
  viaje_aun_no_abonado = "Viagem ainda não paga";
  falta_agregar_metodo_de_pago_valido =
    "Falta adicionar uma forma de pagamento válida";
  cambiar_metodo_de_pago = "Mudar o metodo de pagamento";
  tarjeta_terminada_en = "Cartão finalizado em";
  metodo_de_pago_registrado_con_exito =
    "Método de pagamento registrado com sucesso";
  guardar_metodo_de_pago = "Salvar forma de pagamento?";
  metodo_de_pago = "Forma de pagamento";
  para_continuar_debes_activar_el_gps = "Para continuar você deve ativar o GPS";
  viaje_no_aceptado = "Viagem não aceita";
  intentaremos_ofrecerte_una_mejor_oferta =
    "Tentaremos oferecer-lhe uma oferta melhor";
  viaje_aceptado_correctamente = "Viagem aceita com sucesso";
  buscar_calle = "Pesquisar rua";
  no_se_encontro_ninguna_direccion = "Nenhum endereço encontrado";
  direccion_de_partida = "Endereço de partida";
  numero_de_tarjeta_credito_debito = "Número do cartão (crédito ou débito)";
  debe_estar_entre_1_y_12 = "Deve estar entre 1 e 12";
  solo_acepta_numeros = "Aceita apenas números";
  debe_contener_16_numeros = "Deve conter 16 números";
  numero = "Número";
  titular_tarjeta = "Nome completo";
  numero_de_identificacion = "Número de identificação (DNI, PAS)";
  expira_mm = "Expiração (MM)";
  expira_aaaa = "Expiração (AAAA)";
  cvv = "CVV";
  agregar_metodo_de_pago = "Adicionar forma de pagamento";
  total = "Total";
  importe_acreditado = "Valor creditado";
  datos_de_pasajero = "Dados do passageiro";
  todos = "Todos";
  ver_en_google_maps = "Ver no Google Maps";
  modelo = "Modelo";
  estado = "Estado";
  importe = "Quantia";
  nombre_conductor = "Nome do motorista";
  fecha_hora = "Data/Hora";
  ultimo_mes = "Último mês";
  ultimos_tres_meses = "Últimos três meses";
  ultimos_seis_meses = "Últimos seis meses";
  filtrar_por = "Filtrar por";
  historial_de_viajes = "Histórico de viagens";
  valoracion_enviada_correctamente = "Comentário enviado corretamente";
  viaje_finalizado_correctamente = "Viagem concluída com sucesso";
  ruta_activada_correctamente = "Rota ativada corretamente";
  activar_ruta_de_viaje = "Ativar rota de viagem";
  finalizar_viaje = "Finalizar viagem";
  levantar_pasajero = "Levantar passageiro";
  ver_recorrido_en_google_maps = "Veja rota no Google Maps";
  ver_recorrido = "Veja rota";
  enviar_valoracion = "Enviar revisão";
  transito_activado_correctamente = "Trânsito ativado corretamente";
  no_es_posible_activar_el_tránsito_debido_a_que_tu_ubicación_no_es_correcta =
    "Não é possível ativar o transporte público porque sua localização não está correta";
  no_es_posible_finalizar_el_viaje_debido_a_que_tu_ubicación_no_es_correcta =
    "Não é possível encerrar a viagem porque sua localização não está correta";
  ayudanos_a_mejorar_nuestro_servicio_y_valora_los_siguientes_items =
    "Ajude-nos a melhorar nosso serviço e avalie os seguintes itens";
  viaje_finalizado = "Viagem concluída";
  en_viaje = "Em viagens";
  te_avisaremos_cuando_se_encuentre_en_tu_ubicacion =
    "Iremos notificá-lo quando estiver em sua localização";
  conductor_en_camino = "Motorista a caminho";
  tiempo_de_llegada_estimado = "Hora de chegada (estimada)";
  buscar_en = "Procure em";
  ruta_de_viaje_activada = "Rota de viagem ativada";
  notificacion_de_pickup = "Notificação de retirada";
  en_instantes_iniciara_el_recorrido_para_venir_a_buscarte =
    "Em instantes a jornada começará a chegar e buscá-lo.";
  dominio = "Domínio";
  vehiculo = "Veículo";
  hemos_encontrado_un_conductor_para_ti = "Encontramos um driver para você";
  lo_aceptas = "Você aceita isso?";
  tienes_un_viaje_asignado = "Você tem uma viagem atribuída";
  estamos_buscando_un_conductor_cercano_para_ti =
    "Estamos procurando um motorista próximo para você...";
  tienes_un_viaje_con_destino_a = "Você tem uma viagem para:";
  vas_a_cerrar_la_sesion = "Você vai sair?";
  pendiente_de_asignar_conductor = "Atribuição de driver pendente";
  viaje_cancelado_con_exito = "Viagem cancelada com sucesso";
  el_viaje_no_podra_recuperarse_posterior_a_esta_accion =
    "A viagem não pode ser recuperada após esta ação";
  cambiar_idioma = "Mudar idioma";
  seleccionar_idioma = "Selecione o idioma";
  selecciona_idioma = "Selecione o idioma";
  continuar = "Continuar";
  seleccionar_localidad = "Selecione o local";
  selecciona_localidad = "Selecione o local";
  activar_cuenta = "Ativar conta";
  ingresa_el_codigo_de_activacion =
    "Digite o código de ativação o que você recebeu em sua caixa de correio";
  codigo_de_activacion = "Código de ativação";
  cambiar_contrasena = "Alterar a senha";
  nueva_contrasena = "Nova senha";
  repetir_contrasena = "Repetir a senha";
  guardar_cambios = "Guardar mudanças";
  crear_cuenta_de_pasajero = "Crie uma conta de passageiro";
  nombre = "Nome";
  apellido = "Sobrenome";
  email = "E-mail";
  telefono = "Telefone";
  contrasena = "Senha";
  repetir_contrasena = "Repetir a senha";
  aceptar_las_condiciones_del_servicio = "Aceite as condições de serviço";
  crear_cuenta = "Criar uma conta";
  ingresar = "Conecte-se";
  politica_de_privacidad = "Política de privacidade";
  condiciones_del_servicio = "Condições de serviço";
  campo_obligatorio = "obrigatório";
  las_contrasenas_deben_coincidir = "As senhas devem corresponder";
  email_invalido = "E-mail inválido";
  recuerdame = "Lembra de mim";
  olvidaste_tu_contrasena = "Você esqueceu sua senha";
  cerrar = "Fechar";
  necesitas_ayuda_con_tu_contrasena = "Precisa de ajuda com sua senha?";
  ingresa_el_codigo_de_recuperacion_que_recibiste_en_tu_casilla_de_correo =
    "Digite o código de recuperação o que você recebeu em sua caixa de correio";
  siguiente = "Seguindo";
  ingresa_el_correo_electronico_que_utilizas_en_local_point_y_te_ayudaremos_a_crear_una_nueva_contrasena =
    "Digite o e-mail que você usa no Local Point e nós o ajudaremos a criar uma nova senha";
  reenviar_codigo_de_activacion = "Reenviar Código de Ativação";
  codigo_de_activacion_reenviado_correctamente =
    "Código de ativação encaminhado com sucesso";
  email_requerido = "Email obrigatório";
  codigo_de_recuperacion = "Código de recuperação";
  codigo_de_recuperacion_incorrecto = "Código de recuperação incorreto";
  debe_contener_letras_mayusculas_y_minusculas_al_menos_1_caracter_numerico_y_el_tamano_debe_ser_de_6_a_15_caracteres =
    "Deve conter pelo menos 1 letra maiúscula, 1 caractere numérico, 1 caractere especial e o tamanho deve estar entre 6 e 15 caracteres";
  proceso_de_cambio_de_clave_incorrecto = "Novo processo de chave incorreto";
  cambio_de_contrasena_correcto = "Alteração de senha bem-sucedida";
  cambios_registrados_correctamente = "Alterações registradas corretamente";
  error_al_guardar_cambios = "Erro ao salvar as alterações";
  comenzar = "Começar";
  mis_viajes = "Minhas viagens";
  activo = "Em";
  inactivo = "Desligado";
  menu = "Cardápio";
  editar_perfil = "Editar Perfil";
  cambiar_contrasena = "Alterar a senha";
  cerrar_sesion = "Fechar Sessão";
  idioma = "Linguagem";
  localidad = "Localização";
  contacto = "Contato";
  avatar = "Avatar";
  general = "Em geral";
  otros = "Outros";
  contactos_de_emergencia = "Contatos de emergência";
  vas_a_cambiar_el_estado_de_tu_vehiculo =
    "Você vai mudar o status do seu veículo?";
  tu_nuevo_estado_sera = "Seu novo estado será";
  si = "Sim";
  cancelar = "Cancelar";
  cambio_de_estado_completado_con_exito =
    "Alteração de status concluída com sucesso";
  ahora_tu_estado_es = "Agora seu status é";
  inicio = "lar";
  billetera = "Carteira";
  conductor = "motorista";
  pasajero = "passageiro";
  administrador = "administrador";
  selecciona_imagen = "Selecione a imagem";
  nuevo_viaje = "Nova viagem";
  dispositivo_movil_no_detectado = "Dispositivo móvel não detectado";
  instalar_aplicacion = "Instalar aplicativo";
  datos_incorrectos = "Datos incorretos";
  sin_conexion_a_internet = "Sem conexão com a internet";
  sin_conexion_a_gps = "Sem conexão com a GPS";
  intentando_reconectar = "Tentando se reconectar...";
  conectado = "Conectado";
  desconectado = "Desconectado";
  partida = "Partida";
  destino = "Destino";
  ubicacion_de_partida = "Local inicial";
  ubicacion_destino = "Local de destino";
  banco = "Banco";
  nombre_Banco = "Nome do banco";
  el_correo_electronico_existe_prueba_con_otro = "O e-mail existe, tente outro";
  ya_se_ha_registrado_un_usuario_con_este_email =
    "Um usuário já se registrou com este e-mail.";
  hola = "Olá";
  historial = "Registro";
  no_tienes_viajes_pendientes = "Você não tem viagens pendentes";
  solicita_un_viaje_en_cualquier_momento_en_cualquier_lugar =
    "Solicite uma viagem a qualquer hora, em qualquer lugar";
  selecciona_punto_de_partida = "Selecione o ponto de partida";
  partida_utilizar_ubicacion_actual =
    "Ponto de partida: Use a localização atual";
  ingresar_ubicacion_de_partida = "Insira o local de partida";
  ingresa_punto_de_partida = "Insira o ponto de partida";
  esperando_asignacion_de_viaje = "Aguardando missão de viagem";
  selecciona_punto_destino = "Selecione o ponto de destino";
  ingresa_punto_destino = "Insira o ponto de destino";
  vas_a_confirmar_el_viaje = "Você vai confirmar a viagem?";
  viaje_registrado_con_exito = "Viagem registrada com sucesso";
  tienes_un_viaje_en_curso = "Você tem uma viagem em andamento";
  en_cuanto_finalice_el_mismo_podras_solicitar_uno_nuevo =
    "Assim que terminar, você pode solicitar um novo";
  resumen_del_viaje = "Resumo da viagem";
  trayecto = "Jornada";
  resumen = "Resumo";
  confirmar = "Confirme";
  calcular_trayecto = "Calcular rota";
  vas_a_cancelar_el_viaje_seleccionado =
    "Você vai cancelar a viagem selecionada?";
  para_un_correcto_funcionamiento_de_la_aplicacion_debe_activar_las_notificaciones =
    "Para o correto funcionamento do aplicativo você deve ativar as notificações";
  punto_de_partida = "Ponto de partida";
}

module.exports = {
  ver_recorrido,
  ver_recorrido_en_google_maps,
  enviar_valoracion,
  viaje_finalizado,
  en_viaje,
  te_avisaremos_cuando_se_encuentre_en_tu_ubicacion,
  conductor_en_camino,
  tiempo_de_llegada_estimado,
  buscar_en,
  ruta_de_viaje_activada,
  notificacion_de_pickup,
  en_instantes_iniciara_el_recorrido_para_venir_a_buscarte,
  dominio,
  vehiculo,
  hemos_encontrado_un_conductor_para_ti,
  lo_aceptas,
  tienes_un_viaje_asignado,
  estamos_buscando_un_conductor_cercano_para_ti,
  tienes_un_viaje_con_destino_a,
  vas_a_cerrar_la_sesion,
  pendiente_de_asignar_conductor,
  viaje_cancelado_con_exito,
  el_viaje_no_podra_recuperarse_posterior_a_esta_accion,
  vas_a_cancelar_el_viaje_seleccionado,
  calcular_trayecto,
  resumen,
  confirmar,
  trayecto,
  cambiar_idioma,
  seleccionar_idioma,
  selecciona_idioma,
  continuar,
  selecciona_localidad,
  seleccionar_localidad,
  activar_cuenta,
  ingresa_el_codigo_de_activacion,
  codigo_de_activacion,
  cambiar_contrasena,
  repetir_contrasena,
  guardar_cambios,
  nueva_contrasena,
  crear_cuenta_de_pasajero,
  nombre,
  apellido,
  email,
  telefono,
  contrasena,
  aceptar_las_condiciones_del_servicio,
  crear_cuenta,
  ingresar,
  politica_de_privacidad,
  condiciones_del_servicio,
  cerrar,
  campo_obligatorio,
  las_contrasenas_deben_coincidir,
  email_invalido,
  recuerdame,
  olvidaste_tu_contrasena,
  necesitas_ayuda_con_tu_contrasena,
  ingresa_el_codigo_de_recuperacion_que_recibiste_en_tu_casilla_de_correo,
  siguiente,
  ingresa_el_correo_electronico_que_utilizas_en_local_point_y_te_ayudaremos_a_crear_una_nueva_contrasena,
  reenviar_codigo_de_activacion,
  codigo_de_activacion_reenviado_correctamente,
  email_requerido,
  codigo_de_recuperacion,
  codigo_de_recuperacion_incorrecto,
  debe_contener_letras_mayusculas_y_minusculas_al_menos_1_caracter_numerico_y_el_tamano_debe_ser_de_6_a_15_caracteres,
  proceso_de_cambio_de_clave_incorrecto,
  cambio_de_contrasena_correcto,
  cambios_registrados_correctamente,
  error_al_guardar_cambios,
  comenzar,
  mis_viajes,
  activo,
  inactivo,
  menu,
  editar_perfil,
  cerrar_sesion,
  idioma,
  localidad,
  contacto,
  avatar,
  general,
  otros,
  contactos_de_emergencia,
  vas_a_cambiar_el_estado_de_tu_vehiculo,
  tu_nuevo_estado_sera,
  si,
  cancelar,
  cambio_de_estado_completado_con_exito,
  ahora_tu_estado_es,
  inicio,
  billetera,
  conductor,
  pasajero,
  administrador,
  selecciona_imagen,
  nuevo_viaje,
  dispositivo_movil_no_detectado,
  instalar_aplicacion,
  datos_incorrectos,
  sin_conexion_a_internet,
  sin_conexion_a_gps,
  intentando_reconectar,
  conectado,
  desconectado,
  partida,
  destino,
  ubicacion_de_partida,
  ubicacion_destino,
  banco,
  nombre_Banco,
  titular,
  el_correo_electronico_existe_prueba_con_otro,
  ya_se_ha_registrado_un_usuario_con_este_email,
  hola,
  historial,
  no_tienes_viajes_pendientes,
  solicita_un_viaje_en_cualquier_momento_en_cualquier_lugar,
  selecciona_punto_de_partida,
  partida_utilizar_ubicacion_actual,
  ingresar_ubicacion_de_partida,
  ingresa_punto_de_partida,
  esperando_asignacion_de_viaje,
  selecciona_punto_destino,
  ingresa_punto_destino,
  vas_a_confirmar_el_viaje,
  viaje_registrado_con_exito,
  tienes_un_viaje_en_curso,
  en_cuanto_finalice_el_mismo_podras_solicitar_uno_nuevo,
  resumen_del_viaje,
  ayudanos_a_mejorar_nuestro_servicio_y_valora_los_siguientes_items,
  no_es_posible_finalizar_el_viaje_debido_a_que_tu_ubicación_no_es_correcta,
  no_es_posible_activar_el_tránsito_debido_a_que_tu_ubicación_no_es_correcta,
  transito_activado_correctamente,
  levantar_pasajero,
  finalizar_viaje,
  activar_ruta_de_viaje,
  ruta_activada_correctamente,
  viaje_finalizado_correctamente,
  valoracion_enviada_correctamente,
  historial_de_viajes,
  filtrar_por,
  ultimo_mes,
  ultimos_tres_meses,
  ultimos_seis_meses,
  fecha_hora,
  nombre_conductor,
  importe,
  estado,
  modelo,
  ver_en_google_maps,
  todos,
  datos_de_pasajero,
  total,
  importe_acreditado,
  agregar_metodo_de_pago,
  numero,
  titular_tarjeta,
  numero_de_identificacion,
  expira_mm,
  expira_aaaa,
  cvv,
  debe_contener_16_numeros,
  solo_acepta_numeros,
  debe_estar_entre_1_y_12,
  numero_de_tarjeta_credito_debito,
  direccion_de_partida,
  no_se_encontro_ninguna_direccion,
  buscar_calle,
  no,
  viaje_aceptado_correctamente,
  viaje_no_aceptado,
  intentaremos_ofrecerte_una_mejor_oferta,
  para_continuar_debes_activar_el_gps,
  metodo_de_pago,
  guardar_metodo_de_pago,
  metodo_de_pago_registrado_con_exito,
  tarjeta_terminada_en,
  cambiar_metodo_de_pago,
  falta_agregar_metodo_de_pago_valido,
  viaje_aun_no_abonado,
  avisar_a_pasajero,
  avisar_al_pasajero_que_debe_agregar_un_metodo_de_pago_valido,
  pago,
  cambio_de_estado_de_viaje,
  TraducirEstado,
  para_un_correcto_funcionamiento_de_la_aplicacion_debe_activar_las_notificaciones,
  no_es_posible_obtener_el_token_de_notificaciones,
  permitir_notificaciones,
  conductor_asignado,
  el_conductor_esta_esperandote,
  pagar_viaje,
  viaje_abonado,
  buscando_conductor,
  pendiente_de_abonar,
  punto_de_partida,
  punto_destino,
  tu_ubicacion,
  cargando_mapa,
  sin_servicio_en_tu_zona,
  calcular,
  borrar,
  centrar,
  descargar,
  cargando,
  tocar_afuera_para_cerrar,
  sin_datos,
  recibo,
};
